<template>
  <div>
    <div class="columns is-mobile" v-for="(row, idx) in localRows" :key="idx">
      <div class="column">
        <b-field :label="(!hideHeader && idx === 0) ? $t('integrations.key') : ''">
          <b-input v-model="row.key" :placeholder="$t('integrations.paramKeyPlaceholder')" @input="emitChange" :disabled="readOnly" />
        </b-field>
      </div>
      <div class="column">
        <b-field :label="(!hideHeader && idx === 0) ? $t('integrations.value') : ''">
          <b-input v-model="row.value" :placeholder="$t('integrations.paramValuePlaceholder')" @input="emitChange" :disabled="readOnly" />
        </b-field>
      </div>
      <div class="column is-narrow is-flex is-align-items-flex-end">
        <b-button v-if="!readOnly" type="is-danger" @click="removeRow(idx)" icon-left="delete"></b-button>
        <b-button v-else type="is-danger" icon-left="delete" disabled style="visibility: hidden;"></b-button>
      </div>
    </div>
    <b-button v-if="!readOnly" type="is-primary" icon-left="plus" @click="addRow">{{ $t('integrations.addRow') }}</b-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from 'vue'

type Row = { key: string; value: string }

export default defineComponent({
  name: 'KeyValueList',
  props: {
    modelValue: {
      type: Array as PropType<Row[]>,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const localRows = ref<Row[]>(props.modelValue && props.modelValue.length ? props.modelValue.map(r => ({ ...r })) : [{ key: '', value: '' }])

    watch(() => props.modelValue, (val) => {
      if (!val) return
      // replace local when parent provides new
      localRows.value = val.length ? val.map(r => ({ ...r })) : [{ key: '', value: '' }]
    }, { deep: true })

    const emitChange = () => {
      emit('update:modelValue', localRows.value.map(r => ({ ...r })))
    }

    const addRow = () => {
      localRows.value.push({ key: '', value: '' })
      emitChange()
    }

    const removeRow = (idx: number) => {
      if (localRows.value.length <= 1) {
        localRows.value.splice(0, 1, { key: '', value: '' })
        emitChange()
        return
      }
      localRows.value.splice(idx, 1)
      emitChange()
    }

    return { localRows, addRow, removeRow, emitChange }
  }
})
</script>


